import { useEffect, useRef } from "react";
import { api, type ChatReceipt } from "../lib/api";

/**
 * Observe the hosting Hub's saved inputs while its Runtime may be absent.
 * This is not a poll of Agent work: ordinary records still arrive by SSE.
 * The receipt endpoint neither wakes the Runtime nor renews its idle time.
 */
export function useMessageDelivery(sessionId: string, commandIds: string[],
  onReceipt: (commandId: string, receipt: ChatReceipt) => void) {
  const receive = useRef(onReceipt);
  receive.current = onReceipt;
  const ids = commandIds.join(" ");
  useEffect(() => {
    if (!ids) return;
    let closed = false;
    let timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      if (document.visibilityState !== "hidden") {
        for (const id of ids.split(" ")) {
          const receipt = await api.chatReceipt(sessionId, id).catch(() => null);
          if (closed) return;
          if (receipt) receive.current(id, receipt);
        }
      }
      if (!closed) timer = setTimeout(() => { void poll(); }, 2000);
    };
    void poll();
    return () => { closed = true; clearTimeout(timer); };
  }, [sessionId, ids]);
}
